import { render, staticRenderFns } from "./cognition.vue?vue&type=template&id=1a466cf2&scoped=true&"
import script from "./cognition.vue?vue&type=script&lang=js&"
export * from "./cognition.vue?vue&type=script&lang=js&"
import style0 from "./cognition.vue?vue&type=style&index=0&id=1a466cf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a466cf2",
  null
  
)

export default component.exports